var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('board-cell-card',{attrs:{"title":"告警类别雷达图"}},[_c('div',{attrs:{"id":"alarm-radar-chart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }